import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BookPanel } from './BookReader/BookPanel';
import { SampleContent } from './BookReader/SampleContent';

const BookShowcase = () => {
  const [isReaderOpen, setIsReaderOpen] = useState(false);

  const books = [
    { id: 1, title: "The First Clue", image: "/images/book1.jpg" },
    { id: 2, title: "The Case of the Vanishing Cat", image: "/images/book2.jpg" },
    { id: 3, title: "The Case of the Secret Mirror Passage", image: "/images/book3.jpg" },
    { id: 4, title: "The Case of the Glittering Jewel Thief", image: "/images/book4.jpg" },
    { id: 5, title: "The Case of the Ancient Mummy's Curse", image: "/images/book5.jpg" },
    { id: 6, title: "The Case of the Ghost in the Attic", image: "/images/book6.jpg" },
    { id: 7, title: "The Case of the Poison Plot", image: "/images/book7.jpg" },
    { id: 8, title: "The Case of the Runaway Robot", image: "/images/book8.jpg" }
  ];

  return (
    <div className="relative py-20 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 to-blue-900">
        <div className="absolute inset-0" style={{ opacity: 0.1 }}>
          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute h-2 w-2 bg-yellow-300 rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
              animate={{
                scale: [1, 1.5, 1],
                opacity: [0.3, 0.8, 0.3],
              }}
              transition={{
                duration: 2 + Math.random() * 2,
                repeat: Infinity,
                repeatType: "reverse",
              }}
            />
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-5xl font-bold text-center mb-16 text-white"
        >
          Join The Adventure
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {books.map((book, index) => (
            <motion.div
              key={book.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.05, rotate: [-1, 1, -1, 0] }}
              className="relative group"
            >
              {/* Book Number Star */}
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-yellow-300 rounded-full z-10 flex items-center justify-center transform rotate-12 shadow-lg">
                <span className="text-slate-900 font-bold">#{book.id}</span>
              </div>

              {/* Book Cover */}
              <motion.div
                className="relative rounded-lg overflow-hidden shadow-2xl bg-slate-800"
                whileHover={{ scale: 1.02 }}
                style={{ aspectRatio: '3/4' }}
              >
                <div className="absolute inset-0 flex items-center justify-center">
                  <img 
                    src={book.image} 
                    alt={book.title}
                    className="w-full h-full object-contain"
                  />
                </div>
                
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-white text-xl font-bold">{book.title}</h3>
                  </div>
                </div>
              </motion.div>

              {/* Decorative Elements */}
              <motion.div
                className="absolute -z-10 inset-0 bg-blue-400/20 rounded-lg blur-xl"
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                whileHover={{ scale: 1.2, opacity: 0.4 }}
              />
            </motion.div>
          ))}
        </div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="text-center mt-16"
        >
          <button 
            onClick={() => setIsReaderOpen(true)}
            className="bg-yellow-400 hover:bg-yellow-300 text-slate-900 font-bold py-4 px-8 rounded-full text-xl shadow-xl transform transition hover:scale-105"
          >
            Start Reading Now!
          </button>
        </motion.div>

        {/* Book Reader Panel */}
        <BookPanel
          isOpen={isReaderOpen}
          onClose={() => setIsReaderOpen(false)}
          title="The First Clue"
        >
          <SampleContent book={books[0]} />
        </BookPanel>
      </div>
    </div>
  );
};

export default BookShowcase;